import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
import React from 'react';
var FolderKeyOpen = function FolderKeyOpen(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#788590' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 18L5.14 10H22.21L19.93 18.5C19.7 19.37 18.92 20 18 20H3C1.89 20 1 19.1 1 18V6C1 4.89 1.89 4 3 4H9L11 6H18C18.53 6 19.04 6.21 19.41 6.59C19.79 6.96 20 7.47 20 8H3V18ZM17.83 15.99H18.85L19.43 14.06L14.14 14.05C14.05 12.91 13.15 12.09 11.81 12.09C11 12.08 10.13 12.39 9.39 12.94C8.65 13.49 8.11 14.23 7.88 15.01C7.65 15.78 7.75 16.53 8.17 17.08C8.58 17.63 9.28 17.94 10.09 17.94C11.43 17.94 12.81 17.13 13.56 15.99H15.78L15.21 17.94H17.26L17.83 15.99ZM11 14C10.73 14 10.48 14.11 10.29 14.29C10.11 14.48 10 14.73 10 15C10 15.56 10.45 16 11 16C11.27 16 11.52 15.89 11.71 15.71C11.89 15.52 12 15.27 12 15C12 14.73 11.89 14.48 11.71 14.29C11.52 14.11 11.27 14 11 14Z",
    fill: color
  }));
};
export default /*#__PURE__*/React.memo(FolderKeyOpen);